import { render } from "./UserProfile.vue?vue&type=template&id=149068b9"
import script from "./UserProfile.vue?vue&type=script&lang=js"
export * from "./UserProfile.vue?vue&type=script&lang=js"

import "./UserProfile.vue?vue&type=style&index=0&id=149068b9&lang=scss"
script.render = render

export default script